import { render, staticRenderFns } from "./CheckMailPage.vue?vue&type=template&id=eedaaeb6&scoped=true&"
import script from "./CheckMailPage.vue?vue&type=script&lang=js&"
export * from "./CheckMailPage.vue?vue&type=script&lang=js&"
import style0 from "./CheckMailPage.vue?vue&type=style&index=0&id=eedaaeb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eedaaeb6",
  null
  
)

export default component.exports